import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DesignSystemModule } from 'src/theme/design-system/design-system.module';
import { CardUserComponent } from './card-user/card-user.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RankingPageRoutingModule } from './ranking-routing.module';

import { RankingPage } from './ranking.page';
import { ListComponent } from './list/list.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RankingPageRoutingModule,
    ComponentsModule,
    DesignSystemModule
  ],
  declarations: [RankingPage,CardUserComponent,ListComponent],
  exports:[RankingPage,CardUserComponent,ListComponent],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class RankingPageModule {}
